const PATH = 'fe.pages.test_attempts';

const messages = {
  subtitle: {
    key: `${PATH}.subtitle`,
    defaultValue: 'Review your performance on your most recent attempt.'
  },
  logoDescription: {
    key: `${PATH}.logo_description`,
    defaultValue: 'Certification Logo'
  },
  exitTest: {
    key: `${PATH}.exit_test`,
    defaultValue: 'Save and Exit'
  },
  back: {
    key: `${PATH}.back`,
    defaultValue: 'Back'
  },
  loadingTitle: {
    key: `${PATH}.loading_title`,
    defaultValue: 'Loading Test…'
  },
  unableToLoadTitle: {
    key: `${PATH}.unable_to_load_title`,
    defaultValue: 'Unable to Load Test'
  }
};

export default messages;
